import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import Table from "../../Common/Table";
import TableFields from "../../../constants/CapacityChange/ApprovalView.json";
import RequestViewModal from "../RequestViewModal";
import { bindActionCreators } from "redux";
import { getCapacityChangeRequestData } from "../../../store/actions/CapacityChange";
import ListPagination from "../../Common/ListPagination";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import { entityTypeList } from "../CreateFilters";
import moment from "moment";
import { REQUEST_STATUSES } from "../ViewFilters";
import { StatusPill } from "../../../constants/assets/containers";
import { isValNull } from "../../../utils";

const pageRequest = {
  pageLimit: 15,
};

const ViewTab = ({
  capacityChangeRequests,
  getCapacityChangeRequests,
  userAttributes,
  carrierList,
  allMenuActions,
  activeFilters,
}) => {
  const [initialState, setInitialState] = useState({
    capacityChangeRequests: [],
    paginatedRequest: [],
    currentPage: 1,
  });
  const [viewModalVisibility, setViewModalVisibility] = useState(false);
  const [activeRequest, setActiveRequest] = useState({});
  const [isStatusRequested, toggleStatusRequested] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPage, setNextPage] = useState(-1);
  const [prevPage, setPrevPage] = useState(-1);
  const allActions = MenuActionsMappings[MenuNames.MANUAL_SLOT_CAPACITY_UPDATE];

  useEffect(() => {
    const values = { ...initialState };
    values.capacityChangeRequests = parseRequestData();
    const [offset, limit] = getPaginatedRequest(
      values.capacityChangeRequests,
      1
    );
    values.paginatedRequest = values.capacityChangeRequests.slice(
      offset,
      limit
    );
    setInitialState(values);
    if (capacityChangeRequests.length > pageRequest.pageLimit) {
      setNextPage(2);
      setPrevPage(-1);
    }
  }, [capacityChangeRequests]);

  const getSortOrder = () => {
    if (
      allMenuActions.hasOwnProperty(allActions.APPROVE) &&
      allMenuActions[allActions.APPROVE]
    ) {
      return "asc";
    } else {
      return "desc";
    }
  };

  const getPaginatedRequest = (requests, page) => {
    const maxLimit = Math.min(requests.length, pageRequest.pageLimit * page);
    const offset = pageRequest.pageLimit * (page - 1);
    return [offset, maxLimit];
  };

  const getFieldValue = (capacityDetails, key) => {
    switch (key) {
      case "request_id":
      case "actions": {
        return (
          <span
            onClick={() => {
              setViewModalVisibility(true);
              setActiveRequest(capacityDetails);
              if (capacityDetails.status == "REQUESTED") {
                toggleStatusRequested(true);
              } else {
                toggleStatusRequested(false);
              }
            }}
            className={"edit-options cursor-pointer"}
          >
            {key == "actions" ? "View" : capacityDetails?.request_id}
          </span>
        );
      }
      case "status": {
        return (
          <StatusPill
            isPending={
              capacityDetails.status == "REQUESTED" ||
              capacityDetails.status == "PROCESSING"
            }
            isAccepted={capacityDetails.status == "APPROVED"}
          >
            {capacityDetails.status}
          </StatusPill>
        );
      }
    }
    return capacityDetails[key];
  };

  const parseRequestData = () => {
    let requestData = [];
    (capacityChangeRequests || []).map((request) => {
      requestData.push({
        request_id: request?.request_id,
        status: request?.status,
        requested_by: request?.requested_by,
        requested_at: request?.requested_at,
        updated_by: request?.updated_by,
        updated_at: request?.updated_at,
        carrier_type: request?.capacity_change_details[0]?.carrier_type,
        entity_name: request?.capacity_change_details[0]?.entity_name,
        entity_type: request?.capacity_change_details[0]?.entity_type,
        entity_id: request?.capacity_change_details[0]?.entity_id,
        city_name: request?.capacity_change_details[0]?.city_name,
        date: request?.capacity_change_details[0]?.date,
        capacity_change_details: request?.capacity_change_details,
        gigs: request?.capacity_change_details
          .reduce((gigNames, capacity_details) => {
            gigNames.push(capacity_details.slot_name);
            return gigNames;
          }, [])
          .join(","),
      });
    });
    return requestData;
  };

  const handleNavClick = (action) => {
    const values = { ...initialState };
    if (action === "prev") {
      const [offset, limit] = getPaginatedRequest(
        values.capacityChangeRequests,
        currentPage - 1
      );
      values.paginatedRequest = values.capacityChangeRequests.slice(
        offset,
        limit
      );
      setPrevPage(prevPage - 1);
      setNextPage(nextPage + 1);
      setCurrentPage(currentPage - 1);
    } else {
      const [offset, limit] = getPaginatedRequest(
        values.capacityChangeRequests,
        currentPage + 1
      );
      values.paginatedRequest = values.capacityChangeRequests.slice(
        offset,
        limit
      );
      if (prevPage == -1) {
        setPrevPage(1);
      } else {
        setPrevPage(prevPage + 1);
      }
      setNextPage(nextPage + 1);
      setCurrentPage(currentPage + 1);
      if (
        values.paginatedRequest.length < pageRequest.pageLimit ||
        limit == values.capacityChangeRequests.length
      ) {
        setNextPage(-1);
      }
    }
    setInitialState(values);
  };

  const getDefaultViewRequest = () => {
    const filters = {
      entity_type: entityTypeList[0].entity_type,
      entity_ids: [activeFilters.entity_id],
      carrier_types: [activeFilters.carrier_type],
      start_date: activeFilters.start_date
        ? activeFilters.start_date
        : moment(new Date()).format("YYYY-MM-DD"),
      end_date: activeFilters.end_date
        ? activeFilters.end_date
        : moment(new Date()).add(4, "days").format("YYYY-MM-DD"),
      status: activeFilters.status
        ? activeFilters.status
        : REQUEST_STATUSES[3].label,
      sort_order: getSortOrder(),
      request_id: activeFilters.request_id,
    };
    return filters;
  };

  return (
    <div>
      <Table
        wrapContents={true}
        list={initialState.paginatedRequest}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
      {initialState.capacityChangeRequests ? (
        <ListPagination
          nextPage={nextPage}
          prevPage={prevPage}
          handleNavClick={handleNavClick}
        />
      ) : null}
      {viewModalVisibility ? (
        <RequestViewModal
          handleClose={() => setViewModalVisibility(false)}
          capacityChangeRequest={activeRequest}
          isStatusRequested={isStatusRequested}
          getCapacityChangeRequests={() =>
            getCapacityChangeRequests(getDefaultViewRequest(), {
              page: 1,
              pageSize: 10,
            })
          }
        />
      ) : null}
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getCapacityChangeRequests: bindActionCreators(
      getCapacityChangeRequestData,
      dispatch
    ),
  };
}

function mapStateToProps(state) {
  const { MenuActions } = state;
  return {
    allMenuActions: MenuActions.allMenuActions,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewTab);
